<template>
	<v-dialog persistent max-width="390" v-model="dialog">
		<v-btn slot="activator">
        	MOVE
        </v-btn>
        <v-card :key="resetAll">
            <v-toolbar flat :color="collection.color">
            	<v-toolbar-title class="headline">Move {{collection.collection}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
            	<v-subheader >Choose Group</v-subheader>
            
            	<v-select light class="mx-3"
            	  v-model="groupId"
		          :items="groups"
		          outline
		          item-text="groupName"
		          item-value="groupId"
		          label="Destination Group"
		        ></v-select>
        	</v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click.native="resetForm">Cancel</v-btn>
                <v-btn color="green darken-1" flat 
                    @click.native="moveCollection">MOVE
                </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
data () {
	return {
		dialog: false,
		resetAll: 1,
		groupId: null,
	}
},

props: ['collection', 'groups'],

methods : {
	...mapActions(['rcMoveCollection']),

	async moveCollection() {
		console.log("Move Collection: ", { collectionId: this.collection.collectionId, destinationGroupId: this.groupId })
		await this.rcMoveCollection({ collectionId: this.collection.collectionId, destinationGroupId: this.groupId })		
		this.$emit('refresh', this.groupId)
		this.resetForm()
	},

	resetForm() {
		this.resetAll=this.resetAll+1
		this.dialog=false
	},

},
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/RoomCollector/MoveDialog.vue